import { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { gsap } from "gsap";

const LogoLoader = () => {
  useEffect(() => {
    // Get the path element
    const path = document.querySelector("#outer-stroke path") as SVGPathElement;

    if (path) {
      // Set up the initial styles for the path
      const dashLength = 95; // Length of the dash
      const gapLength = 5; // Length of the gap
      path.style.strokeDasharray = `${dashLength} ${gapLength}`;

      // Animate the stroke
      gsap.to(path, {
        strokeDashoffset: `-${dashLength + gapLength}`,
        duration: 2,
        repeat: -1,
        ease: "power2.inOut",
      });
    }
  }, []);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <svg
        width="100"
        height="100"
        viewBox="0 0 182 243"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="3.5" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <g transform="matrix(1,0,0,1,477.503,-1027.76)">
          <g
            id="outer-stroke"
            transform="matrix(1.55726,0,0,1.55726,-1276.43,140.355)"
          >
            <path
              d="M527.521,723.181C520.998,723.181 515.71,717.893 515.71,711.37C515.71,683.075 515.71,611.7 515.71,583.877C515.71,577.607 520.793,572.524 527.063,572.524C542.143,572.524 566.901,572.524 566.901,572.524C595.154,572.524 618.092,595.462 618.092,623.715C618.092,642.451 608.005,658.85 592.969,667.771C592.969,667.771 614.733,698.354 625.923,714.078C627.174,715.835 627.338,718.143 626.35,720.06C625.361,721.977 623.385,723.181 621.229,723.181L527.521,723.181Z"
              style={{
                fill: "none",
                stroke: "rgba(21, 184, 166)",
                strokeWidth: "3.35px",
                filter: "url(#glow)",
              }}
            />
          </g>
        </g>
      </svg>
    </Box>
  );
};

export default LogoLoader;
